import {
  MetadataConfiguration,
  MetadataConfigurationComposer,
  MetadataConfigurationFieldSimple
} from "@/server/app.dtos";

export function GenerateMetadataComposer(
  current: MetadataConfiguration
): MetadataConfigurationComposer {
  const data = new MetadataConfigurationComposer();
  data.configuration = current;
  data.metadata = [];
  if (current != null && current.groups != null) {
    for (let i = 0; i < current.groups.length; i++) {
      const group = current.groups[i];
      if (group.fields != null) {
        for (let j = 0; j < group.fields.length; j++) {
          const field = group.fields[j];
          const item = new MetadataConfigurationFieldSimple();
          item.idMetadataField = field.idMetadataField;
          item.value = field.value;
          item.options = field.options;
          data.metadata.push(item);
        }
      }
    }
  }
  return data;
}
